import { render, staticRenderFns } from "./CategoryPrincipleAdmin.vue?vue&type=template&id=6500c15a&"
import script from "./CategoryPrincipleAdmin.vue?vue&type=script&lang=js&"
export * from "./CategoryPrincipleAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports